import React, { useState, useEffect } from "react";
import "../news/stylenews.css";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { getFiles } from "../../services/index";
import moment from "moment";
import { baseURL,fileUrl } from "../../constants/index";
import { Pagination } from "antd";
export function Resource() {
  const [fileArr, setFileArr] = useState([]);
  const [fileTotal, setFileTotal] = useState(0);
  const getFileArr = () => {
    getFiles().then((res) => {
      if(res.data){
        setFileArr(res.data);
        setFileTotal(res.data.length);
      }
    });
  };
  useEffect(() => {
    getFileArr();
  }, []);
  return (
    <div className="resource_div">
      <div className="news_list_div">
        <div className="sensor_category">
          <div className="sensor_category_items">
            <div className="category_item category_item_active">
              <span className="category_link">文件下载</span>
            </div>
          </div>
        </div>
        <div
          id="news_list_content_id"
          className="news_list_content"
          data-animation="once"
          loaded="true"
          min-height="417"
          animated="true"
        >
          <div className="news_litem">
            <div className="news_litem_news">
              {fileArr.map((i) => {
                return (
                  <div
                    className="p_articles"
                    data-dismoveable=""
                    data-foreachitem=""
                    key={i.id}
                  >
                    <div className="p_content">
                      <div className="p_header">
                        <div className="p_TitleBox">
                          <a
                            href={baseURL+fileUrl+i.name}
                            target="_self"
                          >
                            <h3 className="p_title">
                              <div
                                className="font"
                                title={i.name}
                              >
                                {" "}
                                {i.name}
                              </div>
                            </h3>
                          </a>
                        </div>
                        <div className="p_assist">
                          <div className="p_TimeBox ">
                            <div className="p_AssistNameA">
                              <div className="font">
                                <span>发布时间：</span>
                              </div>
                            </div>
                            <div className="p_time">
                              <div className="font">
                              {moment(i.create_time).format("YYYY-MM-DD")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p_SummaryBox ">
                        <div className="p_nameB">
                          <div className="font">
                            <span className="i_summary">下载量：</span>
                          </div>
                        </div>
                        <article className="p_summary">{i.download_num}</article>
                        <div className="p_nameB">
                          <div className="font">
                            <span className="i_summary">文件大小：</span>
                          </div>
                        </div>
                        <article className="p_summary">{i.file_size}</article>
                      </div>
                    </div>
                  </div>
                );
              })}
              <div
                className="p_ListHline"
                data-dismoveable=""
                data-foreachitem=""
              ></div>
            </div>
          </div>
          <div className="page">
                <Pagination
                  showQuickJumper
                  defaultCurrent={1}
                  total={fileTotal}
                  showSizeChanger={false}
                  pageSize={2}
                />
              </div>
        </div>
      </div>
      <TopMenu />
    </div>
  );
}
